import { Button, ButtonColors } from '@chiroup/components';
import Header from '../layout/Header';
import Tabs from '../layout/Tabs';
import { TabComponentParams } from './IntegrationRoutes';
import { integrationService } from '../../services/integration.service';
import { ChangeEvent, useRef } from 'react';
import { getExtension } from '../common/helpers/getExtension';
import { isSupportedTextExtension } from '@chiroup/core';
import React from 'react';
import uploadService from '../../services/upload.service';
import Translator from 'short-uuid';

type Props = TabComponentParams;

const IntegrationMain: React.FC<Props> = ({
  tabs = [],
  me,
  tab,
  featureTitle,
  tabTitleClassName,
  tabContainerClassName,
}) => {
  const inputFileRef = useRef<HTMLInputElement>(null);
  const [uploadFile, setUploadFile] = React.useState<File | null>(null);
  const [reverseLookup, setReverseLookup] = React.useState<string | null>(null);
  const translator = Translator(undefined, {
    consistentLength: true,
  });

  const HANDLE = {
    upload: async (e: React.FormEvent<HTMLFormElement>) => {
      if (e && e.preventDefault) e.preventDefault();
      if (e && e.stopPropagation) e.stopPropagation();
      if (!uploadFile) return;

      /**
       * The change already checks this, but what the heck...
       */
      const extension = getExtension(
          uploadFile?.name?.toLowerCase(),
        )?.toLowerCase(),
        extensionOkay = isSupportedTextExtension(extension);

      console.log({
        HANDLE_upload: {
          e,
          uploadFile,
          extension,
        },
      });

      if (!extension) {
        alert('Sorry, we need a filename and with an extension.');
        return;
      }

      if (!extensionOkay) {
        alert(
          `Sorry, ${extension} is not recognized as a supported file type.`,
        );
        return;
      }

      const res = await integrationService.upload({
        clinicId: me?.selectedClinic?.ID ?? -1,
        profileId: -1,
        file: uploadFile,
        trace: true,
      });
      console.log({ res });

      const upload = await uploadService.uploadFile(
        uploadFile,
        res.signedUrlResponse,
      );
      console.log({ upload });
      const parsed = await integrationService.parse({
        clinicId: me?.selectedClinic?.ID,
        key: res.key,
        trace: true,
      });
      console.log({ parsed });
    },
    parse: async (key: string) => {
      if (!key) return;

      console.log({
        HANDLE_parse: {
          key,
        },
      });

      const res = await integrationService.parse({
        clinicId: me?.selectedClinic?.ID,
        key,
        trace: true,
      });
      console.log({ res });
    },
    // download: async (e: React.FormEvent<HTMLFormElement>) => {
    //   if (e && e.preventDefault) e.preventDefault();
    //   if (e && e.stopPropagation) e.stopPropagation();
    //   const res = await integrationService.download({
    //     clinicId: me?.selectedClinic?.ID,
    //   });
    //   if (res) {
    //     window.open(res);
    //   }
    // },
    uploadFileChange: async (e: ChangeEvent<HTMLInputElement>) => {
      setUploadFile(null);

      const file: any = (e.target.files || [])[0],
        extension = getExtension(file.name?.toLowerCase())?.toLowerCase(),
        extensionOkay = isSupportedTextExtension(extension);

      if (!file || !extension) {
        alert('Sorry, we need a filename and with an extension.');
        if (inputFileRef?.current) inputFileRef.current.value = '';
        return;
      }

      if (!extensionOkay) {
        alert(
          `Sorry, ${extension} is not recognized as a supported file type.`,
        );
        if (inputFileRef?.current) inputFileRef.current.value = '';
        return;
      }
      setUploadFile(file);
    },
    list: async (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      if (e && e.preventDefault) e.preventDefault();
      if (e && e.stopPropagation) e.stopPropagation();

      const res = await integrationService.remote({
        clinicId: me?.selectedClinic?.ID,
        trace: true,
        // script: [{ action: 'ls', args: { path: 'remits' } }],
        script: [
          {
            action: 'getAll',
            args: {
              path: 'remits',
              each: { transforms: ['buffer-to-string'] },
            },
          },
        ],
        // script: [
        //   {
        //     action: 'ls',
        //     args: {
        //       path: '277',
        //     },
        //   },
        //   {
        //     action: 'put',
        //     args: {
        //       path: '277',
        //       name: 'bwm-test',
        //       type: '.ignore-me',
        //       buffer: 'This is a test.',
        //     },
        //   },
        //   {
        //     action: 'ls',
        //     args: {
        //       path: '277',
        //     },
        //   },
        //   {
        //     action: 'rm',
        //     args: {
        //       path: '277',
        //       name: 'bwm-test',
        //       type: '.ignore-me',
        //     },
        //   },
        // ],

        // submit a claim file
        // script: [
        //   {
        //     action: 'ls',
        //     args: {
        //       path: 'claims',
        //     },
        //   },
        //   {
        //     action: 'put',
        //     args: {
        //       path: 'claims',
        //       name: 'claims-test',
        //       type: '.txt',
        //       buffer: 'This is a test.',
        //     },
        //   },
        // ],
      });
      console.log({ res });
    },
  };

  return (
    <div>
      {tabs && <Tabs tabs={tabs} />}
      <Header title={featureTitle}>
        <div className={tabTitleClassName}>{tab.name}</div>
      </Header>
      <div className={tabContainerClassName}>To be determined.</div>
      <div className="flex m-2 p-4">
        <Button
          text="Yelp!"
          className="btn btn-primary"
          onClick={HANDLE.list}
          color={ButtonColors.primary}
        />
      </div>
      <div className="m-4 p-4 border border-gray-800 rounded-md flex flex-col space-y-4">
        <div>Test Reverse-lookup of a Short-UUID</div>
        <form>
          <input
            className="w-96 rounded-md border border-gray-300 p-2"
            type="text"
            name="rlu"
            id="rlu"
            onChange={(e) => {
              setReverseLookup(translator.toUUID(e.target.value));
              console.log(e);
            }}
          />
        </form>
        <div>
          <pre>{reverseLookup}</pre>
        </div>
      </div>
      <div className="py-4">
        <h1>Test an Upload</h1>
        <div>
          <form onSubmit={HANDLE.upload}>
            <input
              id={`upload-file`}
              name={`upload-file`}
              type="file"
              onChange={HANDLE.uploadFileChange}
              ref={inputFileRef}
            />
            <button
              type="submit"
              className="m-4 p-2 border border-gray-300 bg-gray-50"
            >
              Son of Yelp!
            </button>
          </form>
        </div>
      </div>
      <div>
        <dl></dl>
      </div>
      <pre>
        {`NOTES: 
        
        createPresignedPost
        
        CLAIMS, STATEMENTS
        
        REMITS, CSRREPORTS, 277, 997 and REPORTS`}
      </pre>
    </div>
  );
};

export default IntegrationMain;
